import {
  LineChart,
  PieChart,
  TrendingUp,
  Shield,
  Globe,
  Bell,
} from "lucide-react";
import SectionHeading from "./SectionHeading";

const features = [
  {
    icon: LineChart,
    title: "Net worth over time",
    description:
      "Daily snapshots power a clear chart — filter by month, quarter, year, or all time.",
  },
  {
    icon: PieChart,
    title: "Allocation by category",
    description:
      "See how your portfolio splits across gold, mutual funds, cash, travel points, and more.",
  },
  {
    icon: TrendingUp,
    title: "Assets & liabilities",
    description:
      "Track balances in INR with support for foreign amounts and FX context when you need it.",
  },
  {
    icon: Globe,
    title: "Exchange rates",
    description:
      "Cached FX for quick conversions — so foreign holdings stay understandable at a glance.",
  },
  {
    icon: Bell,
    title: "Scheduled snapshots",
    description:
      "Background jobs keep history consistent — your dashboard stays in sync with the big picture.",
  },
  {
    icon: Shield,
    title: "Account-based access",
    description:
      "Sign in with email and password; your portfolio is scoped to you — not shared or public.",
  },
];

/**
 * Feature grid as an editorial list: hairline-topped entries with a
 * thin-stroke accent icon, two columns on larger screens.
 */
export default function LandingFeatures() {
  return (
    <section id="features" className="scroll-mt-24 py-16 sm:py-24">
      <div className="mx-auto max-w-[800px] px-6">
        <SectionHeading
          eyebrow="Features"
          title="Built for clarity"
          subtitle={
            <>
              Everything in Vaulzo is designed around one question:{" "}
              <span className="text-vaulzo-ink">
                where do you stand, and how is it changing?
              </span>
            </>
          }
        />

        <ul className="mt-14 grid gap-x-12 gap-y-10 sm:grid-cols-2">
          {features.map(({ icon: Icon, title, description }) => (
            <li key={title} className="border-t border-vaulzo-hairline pt-6">
              <Icon className="mb-4 h-5 w-5 text-vaulzo-accent" strokeWidth={1.7} />
              <h3 className="text-[16px] font-semibold text-vaulzo-ink">{title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-vaulzo-faint">
                {description}
              </p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
